import { Component } from '@angular/core';

@Component({
    selector: 'banner',
    templateUrl: 'banner.component.html',
    styleUrl: 'banner.component.scss',
})
export class BannerComponent {
    Array = Array; // Torna o Array global disponível no template
}
